import { AxiosInstance, AxiosResponse } from 'axios';
import { MultiSignificantTerms, SignificantTerms } from '@models/ITechStats';
import AxiosClientBuilder, { ApiName } from '../../AxiosClientBuilder';
import { NodeSelection } from '../../../shared/types';

export type SignificantField =
  | 'keywords'
  | 'affiliations'
  | 'people'
  | 'authors'
  | 'impact.affiliations'
  | 'risk.affiliations'
  | 'impact.level'
  | 'risk.level'
  | 'funder.name';

export type ToMatch = {
  match: SignificantField;
  value: string;
  exact?: boolean;
};

export class OrganizationsSignificantTermsApi {
  private static ROOT = '/significant-terms';

  private static client: AxiosInstance = new AxiosClientBuilder()
    .setApiName(ApiName.Organizations)
    .setPrivate(true)
    .build();

  static getOrganizationsSignificantTerms(
    toMatchArray: ToMatch[],
    aggregationField: SignificantField,
    size?: NodeSelection,
  ): Promise<AxiosResponse<SignificantTerms>> {
    return this.client.get<SignificantTerms>(`${this.ROOT}`, {
      params: {
        toMatch: JSON.stringify(toMatchArray),
        aggregationField,
        size,
      },
    });
  }

  static getOrganizationsMultiSignificantTerms(
    toMatchArray: ToMatch[],
    aggregationField: SignificantField,
  ): Promise<AxiosResponse<MultiSignificantTerms[]>> {
    return this.client.get<MultiSignificantTerms[]>(`${this.ROOT}/multi`, {
      params: {
        toMatch: JSON.stringify(toMatchArray),
        aggregationField,
      },
    });
  }
}
